export const GET_MATCHES_LIST_REQUEST = "GET_MATCHES_LIST_REQUEST";
export const GET_MATCHES_LIST_RESPONSE = "GET_MATCHES_LIST_RESPONSE";
export const GET_MATCHES_LIST_ERROR = "GET_MATCHES_LIST_ERROR";

export const GET_ORGANIZER_LIST_REQUEST = "GET_ORGANIZER_LIST_REQUEST";
export const GET_ORGANIZER_LIST_RESPONSE = "GET_ORGANIZER_LIST_RESPONSE";
export const GET_ORGANIZER_LIST_ERROR = "GET_ORGANIZER_LIST_ERROR";

export const GET_ANALYST_LIST_REQUEST = "GET_ANALYST_LIST_REQUEST";
export const GET_ANALYST_LIST_RESPONSE = "GET_ANALYST_LIST_RESPONSE";
export const GET_ANALYST_LIST_ERROR = "GET_ANALYST_LIST_ERROR";

export const ASSIGN_ANALYST_MATCH_REQUEST = "ASSIGN_ANALYST_MATCH_REQUEST";
export const ASSIGN_ANALYST_MATCH_RESPONSE = "ASSIGN_ANALYST_MATCH_RESPONSE";
export const ASSIGN_ANALYST_MATCH_ERROR = "ASSIGN_ANALYST_MATCH_ERROR";

export const ASSIGN_ORGANIZER_MATCH_REQUEST = "ASSIGN_ORGANIZER_MATCH_REQUEST";
export const ASSIGN_ORGANIZER_MATCH_RESPONSE =
  "ASSIGN_ORGANIZER_MATCH_RESPONSE";
export const ASSIGN_ORGANIZER_MATCH_ERROR = "ASSIGN_ORGANIZER_MATCH_ERROR";

export const FETCHING_MATCHES_REQUEST = "FETCHING_MATCHES_REQUEST";
export const FETCHING_MATCHES_DONE = "FETCHING_MATCHES_DONE";

export const FETCHING_ANALYST_REQUEST = "FETCHING_ANALYST_REQUEST";
export const FETCHING_ANALYST_DONE = "FETCHING_ANALYST_DONE";

export const FETCHING_ORGANIZER_REQUEST = "FETCHING_ORGANIZER_REQUEST";
export const FETCHING_ORGANIZER_DONE = "FETCHING_ORGANIZER_DONE";

export const UPDATING_ANALYST_REQUEST = "UPDATING_ANALYST_REQUEST";
export const UPDATING_ANALYST_DONE = "UPDATING_ANALYST_DONE";

export const UPDATING_PORT_REQUEST = "UPDATING_PORT_REQUEST";
export const UPDATING_PORT_DONE = "UPDATING_PORT_DONE";




